import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';

@Component({
  selector: 'app-product-image-upload',
  templateUrl: './product-image-upload.component.html',
  styleUrls: ['./product-image-upload.component.scss'],
})
/**
 * Image upload component for product page
 */
export class ProductImageUploadComponent {
  @Input() picture!: FormControl;
  @Input() modalTitle: string = 'change-product-image';
  /**
   * Constructor
   */
  constructor(private dialogService: DialogService) {}

  /**
   * Opens modal
   */
  openUpdateImageModal() {
    this.dialogService.openUpdateImageWithControl(
      this.picture,
      (res) => {
        if (res) {
          this.picture.setValue(res);
        }
      },
      undefined,
      this.modalTitle
    );
  }
}
